<template>
    <router-link :to="'/valve/' + valve.slug" class="viewer-grid-item js-close-viewer-nav">
            <div v-on:click="$emit('hide-product-menu')">
                <div class="valve-grid-item__image-container">
                <img :src="valve.image" v-bind:alt="valve.title" class="viewer-grid-item__image">
                </div>
                <span class="viewer-grid-item__title">{{ valve.title }}</span>
            </div>
    </router-link>

    <!--<button v-on:click="$emit('change-valve', valve)">{{valve.title}}</button>-->
</template>

<script>
export default {
  name: 'ValveTile',
  props: {
      valve: Object
  },
//    created() {
//        console.log('valve is:');
//        console.log(this.valve.title);
//    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

</style>
